import moment from 'moment';

/**
 * Check if a date is before yesterday
 *
 * @param  {[type]}  targetDate        Moment date object to check
 * @param  {[type]}  [today=moment()]  Moment date object for today's datetime
 * @return {Boolean}                   Is the target date before yesterday?
 */
export function isBeforeYesterday(targetDate, today = moment()) {
    return targetDate.isBefore(today.clone().subtract(1, 'day'), 'day');
}
